import { apiFetch } from "@core/index";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IUpdatePartnerPayload } from "../utils/types";
import { apiEndpoint } from "../utils/constants";
import { enqueueSnackbar } from "notistack";

export const useUpdatePartner = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (config: { payload: IUpdatePartnerPayload }) => {
      const { referrerID, payloadData } = config.payload;
      const response = await apiFetch<{
        statusCode: number;
        message: string;
        data?: unknown;
      }>(`${apiEndpoint}/${referrerID}`, {
        method: "PATCH",
        body: payloadData,
      });
      return response;
    },
    onSuccess: () => {
      enqueueSnackbar("Partner updated successfully.", {
        variant: "success",
        autoHideDuration: 2000,
      });
      queryClient.invalidateQueries({ queryKey: ["partners"] });
    },
    onError: (error: Error) => {
      enqueueSnackbar("Failed to update partner. Error: " + error.message, {
        variant: "error",
        autoHideDuration: 5000,
      });
    },
  });
};
